import { gql } from '@common/hooks';
import { CommentInfoFragment, CommentInfoFragmentType } from '@common/graphql';

export const SupplierInvitationByTokenQuery = gql`
  query SupplierInvitationByToken($id: ID!) {
    supplierInvitationByToken(id: $id) {
      id
      status
      organization {
        id
        name
      }
      lastComment {
        ...CommentInfoFragment
      }
      createdAt
      createdBy {
        id
        name
      }
    }
  }
  ${CommentInfoFragment}
`;

export type SupplierInvitationByTokenResponse = {
  supplierInvitationByToken: SupplierInvitation;
};

export type SupplierInvitationByTokenVariables = {
  id: string;
};

export type SupplierInvitation = {
  id: string;
  status: string;
  organization: {
    id: string;
    name: string;
  };
  lastComment: CommentInfoFragmentType;
  createdAt: string;
  createdBy: {
    id: string;
    name: string;
  };
};
